module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02-large.493231bc.jpg";